import { Grid, makeStyles, Typography } from "@material-ui/core";
import { Icon } from "../../../../components/base/Icon";
import { ModalBox } from "../../../../components/boxes/ModalBox";
import RemoveIcon from "../../../../assets/images/icons/remove.svg";
import { Image } from "../../../../components/base/Image";
import { POWER_ASSETS_IMAGES } from "../../constants";
import { TextAreaInput } from "../../../../components/base/TextInput";
import { ButtonsGroup } from "../../../../components/buttonsGroup";
import XIcon from "../../../../assets/images/icons/x.png";
import { UploadButton } from "../../../../components/base/UploadButton";
import { COLORS } from "../../../../theme/colors";
import { saveNotification } from "../../../../redux/notification/actions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  termDesc: {
    marginTop: theme.spacing(4),
    lineHeight: 1.2,
  },
  assetsContainer: {
    marginTop: theme.spacing(3.5),
    marginBottom: theme.spacing(4.5),
  },
  assetInfo: {
    marginLeft: theme.spacing(2),
  },
  uploadSignatureText: {
    color: COLORS.darks[0][50],
    fontStyle: "italic",
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    borderBottom: "1px solid",
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
    cursor: "pointer",
  },
}));

export const ApproveAssetsModal = ({ onClose, assets }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const orderImplemetationPlan = () => {
    dispatch(
      saveNotification({
        message: "Here comes success message + guidlines for next steps",
      })
    );
  };

  return (
    <ModalBox width={620} maxWidth="md">
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h2">New Power Asset Approval</Typography>
        <Icon src={RemoveIcon} hoverable onClick={onClose} />
      </Grid>
      <Typography className={classes.termDesc} variant="h4">
        Read and sign the terms sheet below in order to approve the following
        new power assets:
      </Typography>

      <div className={classes.assetsContainer}>
        {assets.map((asset, index) => (
          <Grid
            container
            alignItems="center"
            key={index}
            style={{ marginTop: index > 0 ? 8 : null }}
          >
            <Image src={POWER_ASSETS_IMAGES[asset.type]} width={48} />
            <div className={classes.assetInfo}>
              <Typography variant="h3">{asset.name}</Typography>
              <Typography variant="body2">{asset.address}</Typography>
            </div>
          </Grid>
        ))}
      </div>

      <Typography style={{ fontWeight: "bold", marginBottom: 4 }}>
        Terms sheet
      </Typography>
      <TextAreaInput value="Term sheet details comes here Term sheet details comes here Term sheet details comes here" />

      <Grid container alignItems="flex-end">
        <Icon src={XIcon} />
        <UploadButton
          accept="image/*"
          labelComponent={
            <Typography className={classes.uploadSignatureText}>
              Tap here to add your signature
            </Typography>
          }
        />
      </Grid>

      <ButtonsGroup
        buttons={[
          {
            text: "ORDER IMPLEMENTATION PLAN",
            onClick: orderImplemetationPlan,
          },
          { text: "DOWNLOAD TERMS SHEET" },
          { text: "CANCEL", onClick: onClose },
        ]}
      />
    </ModalBox>
  );
};
